//import Glide from '@glidejs/glide'

export default {
  init() {
    // JavaScript to be fired on the home page
    $('#btnCerrar').on('click',function(){
      console.log('paso por aqui');
      $('#capaPopup').css('display','none');
    })


    
    // let cont = 0;
    // let videoSrc;
    // function cambiarVideo() {
    //   //let video = ;
    //   if(cont == 0) {
    //     videoSrc = 'https://musicalgrease.santacc.homes/wp-content/uploads/2024/08/VideoWebGrease_V1.mp4';
    //     cont = 1;
    //   } else {
    //     videoSrc = $('#myVideo source').attr('src');
    //     cont = 0;
    //   }
      
    //   let anchoPantalla =  $(window).width();
    //   if(anchoPantalla <= 768) {
    //     $('#myVideod').attr('src', videoSrc) ; 
    //   } else {
    //     $('#myVideo').attr('src', videoSrc) 
    //   }
    // }

    // $('#cambio-video').on('click',function(){
    //   cambiarVideo();
    // })
   
    // let glideDest = new Glide('.glide', {
    //   type: 'carrousel',
    //   focusAt: 'center',
    //   perView: 1,
    //   autoplay: 5000,
    //   startAt: 1,
    //   });
    // glideDest.mount();

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js